import { useFiltersContext } from "components/contexts";
import {
  DatePickerChips,
  EnergyTypePicker,
  ChartGranularityTypePicker,
  FiltersWidget,
} from "components/elements/filters";

export const RecordsFilters = ({
  meterDataAvailable,
}: {
  meterDataAvailable?: boolean;
}) => {
  const { dateType } = useFiltersContext();
  const isDay = dateType[0] === "day";

  return (
    <FiltersWidget>
      <>
        <DatePickerChips />
        <EnergyTypePicker meterDataAvailable={meterDataAvailable} />
        {isDay && <ChartGranularityTypePicker />}
      </>
    </FiltersWidget>
  );
};
